module.exports = __webpack_public_path__ + "img/messenger.39d7bb0e.svg";